<template>
  <div>
    <form class="section__content form">
      <h1 class="admin__title">Accounts ({{ accounts.length }})</h1>
      <fieldset v-if="!account" class="form__group">
        <section class="form__item__input input">
          <input placeholder="Search for an account by name... (Prefix Search with id: to search by id)" type="text" class="input__field"  v-model="accountSearch" />
        </section>
        <article v-if="searchMatch(item)" @click="viewUsers(item.id)" v-for="item in accounts" class="admin__form form__item form__item--show-border">
          <h2>({{item.id}}) {{ item.name }}</h2>
        </article>
      </fieldset>
      <fieldset v-if="account" class="form__group">
        <div class="admin__userstitle admin__row">
          <button class="admin__usersback admin__button button button--secondary" @click="cancelViewUsers">Back</button>
          <h2 class="admin__subtitle" v-if="account">Users of: <i>{{ account.name }}</i></h2>
          <h2 class="admin__subtitle">Number of Users: <i>{{ account.account_users.length }}</i></h2>
          <h2 class="admin__subtitle" v-if="account.plan">Plan Type: <i>{{ account.plan.name }}</i></h2>
          <h2 class="admin__subtitle" v-if="account.referred_by_code">Partner Referral: <i>{{ account.referred_by_code }}</i></h2>
        </div>
        <hr>
        <article v-for="user in account.account_users" class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">{{ user.user.name }}</h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">{{ user.user.email }}</h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">{{ user.permissions }}</h1>
          </label>
          <section class="form__item__input input">
            <div v-if="user.user_id != mockingId" @click="becomeUser(user.user_id)" class="admin__button--primary button button--primary">Control User</div>
          </section>
        </article>
        <br>
        <br>
        <hr>
        <article class="form__item form__item">
          <label class="form__item__label">
            <h1 class="form__item__name">Custom Ad Formats</h1>
            <small class="form__item__description">Which custom ads are available to this account?</small>
          </label>

          <section class="admin__input form__item__input input">
            <input type="text" class="input__field" placeholder="Search..."  v-model="adSearch" />
            <div id="admin__category__ul">
              <div v-for="format in getFilteredFormats">
                <a @click.prevent="adSearch = format.name" class="admin__li" v-if="format.name.toUpperCase().indexOf(adSearch.toUpperCase()) > -1 && format.name !== adSearch" href="#">{{ format.name }}</a>
              </div>
            </div>
          </section>
          <section class="admin__input form__item__input">
            <div @click.prevent="addFormat" class="admin__button--primary button button--primary">Add Format</div>
          </section>
        </article>
        <article v-for="format in formatslist" class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">{{ format.name }}</h1>
          </label>
          <section class="admin__input form__item__input input">
            <div @click.prevent="deleteFormat(format.id)" class="admin__button button button--remove">Remove</div>
          </section>
        </article>
        <br>
        <br>
        <hr>
        <article class="form__item form__item">
          <label class="form__item__label">
            <h1 class="form__item__name">CC Image Rights</h1>
            <small class="form__item__description">Should this account only be able to fetch images with creative commons rights from our google search?</small>
          </label>

          <section class="admin__input form__item__input input">
            {{ account.cc_image_rights ? "Enabled" : "Disabled" }}
          </section>
          <section class="admin__input form__item__input">
            <div @click.prevent="updateCCRight" class="admin__button--primary button button--primary">Toggle CC Rights</div>
          </section>
        </article>
        <hr>
        <article class="form__item form__item">
          <label class="form__item__label">
            <h1 class="form__item__name">Current Plan</h1>
            <small class="form__item__description">The current plan id. (WARNING Be careful when using as it ONLY CHANGES PLAN_ID and NO PAYMENT OPTIONS)</small>
          </label>

          <input type="text" class="admin__input input__field form__item__input input" v-model="account.plan_id">

          <section class="admin__input form__item__input">
            <div @click.prevent="updateAccountTier" class="admin__button--primary button button--primary">Update</div>
          </section>
        </article>
        <hr>
        <h1 class="admin__title--smaller">Previous Transactions</h1>
        <article v-for="transaction in getCharges" class="form__item form__item--show-border">
          <label class="form__item__label">
            <h1 class="form__item__name">{{ chargeDate(transaction.created) }}</h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">${{ (transaction.amount / 100) }}</h1>
          </label>
          <label class="form__item__label">
            <h1 class="form__item__name">{{ getRefundStatus(transaction.refunded) }}</h1>
          </label>
          <section class="form__item__input input">
            <div v-if="!transaction.refunded" @click="issueRefund(transaction.id)" class="admin__button button button--tertiary">Issue Refund</div>
          </section>
        </article>
      </fieldset>
    </form>
  </div>
</template>

<script>
    import {mapState} from 'vuex'

    export default {
      name: 'AdminAccounts',
      data () {
        return {
          account: null,
          mockingId: undefined,
          accountSearch: '',
          charges: null,
          adSearch: '',
          formatslist: [],
          formatsToDelete: [],
          formatsToAdd: [],
        }
      },
      beforeMount () {
        if (localStorage.user_id) {
          this.mockingId = localStorage.user_id;
        }
      },
      methods: {
        searchMatch (item) {
          let matches = this.accountSearch.match(/^id:\s*(\d+)/);
          if (matches) {
            return item.id.toString().indexOf(matches[1]) > -1;
          } else {
            return item.name.toUpperCase().indexOf(this.accountSearch.toUpperCase()) > -1;
          }
        },
        chargeDate (date) {
          return this.unixToDate(date)
        },
        issueRefund (id) {
          this.$modal.show('warning', {
            messageText: 'Are you sure you want to issue a refund?',
            buttonText: 'Issue Refund',
            callback: function (params) {
              this.$store.dispatch('accounts/issueRefund', {account_id: this.account.id, charge_id: id, callback: ()=>{
                this.charges = this.$store.getters['accounts/charges'].data;
              }}, this.$snotify);
            }.bind(this)
          })
        },
        cancelViewUsers () {
          this.account = null;
          this.charges = null;
        },
        viewUsers (id) {
          let allAccounts = this.accounts;
          allAccounts.forEach(acc => {
            if (acc.id === id) {
              this.account = acc;
            }
          });
          this.$store.dispatch('accounts/formats/loadCustom', {id: this.account.id}).then(formats => {
            this.formatslist = formats
            this.$store.dispatch('accounts/loadCharges', {accountId: this.account.id,
              callback: ()=>{
                this.charges = this.$store.getters['accounts/charges'].data;
              }}, this.$snotify);
          })
        },
        becomeUser (id) {
          localStorage.user_id = id;
          this.mockingId = id;
          this.$store.dispatch('reloadMe');
        },
        getRefundStatus (status) {
          if (status) {
            return 'Refunded'
          } else {
            return 'Paid'
          }
        },
        addFormat() {
          let ad = this.adSearch;
          this.allFormats.forEach(format => {
            if (format.name === ad) {
              this.formatslist.push(format)
              this.$store.dispatch('accounts/formats/add', { format_id: format.id, account_id: this.account.id })
              this.adSearch = '';
            }
          });
        },
        deleteFormat(id) {
          for (var i = 0; i < this.formatslist.length; i++) {
            if (this.formatslist[i].id === id) {
              this.formatslist.splice(i, 1);
              this.$store.dispatch('accounts/formats/delete', { id })
            }
          }
        },
        updateAccountTier() {
          this.$store.dispatch('accounts/update', { id: this.account.id, plan_id: this.account.plan_id })
        },
        updateCCRight() {
          this.$store.dispatch('accounts/update', { id: this.account.id, cc_image_rights: !this.account.cc_image_rights })
        }
      },
       computed: {
        ...mapState('formats', {
          allFormats: 'allFormats'
        }),
        ...mapState('accounts', {
          accounts: 'all'
        }),
        getCharges () {
          return this.$store.getters['accounts/charges'].data;
        },
        getFilteredFormats () {
          let rtnArray = [];
          let adsArray = [];
          this.formatslist.forEach(format => {
            adsArray.push(format.name)
          });
          if (!this.allFormats) return;
          this.allFormats.forEach(ad => {
            if (!(adsArray.indexOf(ad.name) > -1)) {
              rtnArray.push(ad);
            }
          })
          return rtnArray
        }
      },
      watch: {
        getCharges (newVal) {
          if (newVal) {
            this.charges = newVal;
          }
        }
      }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/admin/AdminAccounts.vue